import Analytics from 'teamdigital-analytics-service-js'
import Promotion from 'teamdigital-promotion-service-js'
import router from '../../router'

// initial state
const state = {
    analytics: new Analytics(process.env.VUE_APP_GOOGLE_ANALYTICS),
    nav: {
        open: false,
    },
    wrapping_paper: null,
    privacy_policy: '',
    promotion: new Promotion({
        start_date: process.env.VUE_APP_PROMO_START_DATE,
        end_date: process.env.VUE_APP_PROMO_END_DATE,
        /**current_phase: process.env.VUE_APP_PROMO_PHASE, // override time controlled phase switching (staging only)
        phases: [
            { phase: 1, start: process.env.VUE_APP_PROMO_START_DATE, end: '2019-04-08 09:59:59' },
            { phase: 2, start: '2019-04-08 10:00:00', end: process.env.VUE_APP_PROMO_END_DATE }
        ]**/
    }, process.env.VUE_APP_ENV),
    loading: false,
    submitting: false, 
}

// getters
const getters = {

}

// actions
const actions = {

    // set the active wrapping paper
    setActiveWrappingPaper({ commit }, string) {
        commit('SET_ACTIVE_WRAPPING', string);
    },

    // set the app loading state
    setLoading({ commit }, bool) {
        commit('SET_LOADING', bool);
    },

    // set the app submitting state
    setSubmitting({ commit }, bool) {
        commit('SET_SUBMITTING', bool);
    },

    // toggle the mobile nav state
    toggleMobileNav({ commit }) {
        commit('TOGGLE_NAV');
    },

    // set the mobile nav state
    closeMobileNav({ commit }) {
        commit('CLOSE_NAV');
    },
}

// mutations
const mutations = {
    
    // sets the loading state of the app
    SET_ACTIVE_WRAPPING(state, string) {
        state.wrapping_paper = string;
    },

    // sets the loading state of the app
    SET_LOADING(state, bool) {
        state.loading = bool;
    },

    // sets the submitting state of the app
    SET_SUBMITTING(state, bool) {
        state.submitting = bool;
    },

    // toggles the nav open state
    TOGGLE_NAV(state) {
        state.nav.open = !state.nav.open;
    },

    // sets the nav state to false
    CLOSE_NAV(bool) {
        state.nav.open = false;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}